import { Row, Col } from 'react-grid-system';
import styled from 'styled-components';
import r from 'render-dom';

import Skeleton from 'components/App/Dashboard/ui/Skeleton';

const Container = styled.div`
    margin: 0 auto;
`;

const RankInfoContainer = styled.div`
    display: flex;
`;

const RankInfoRank = styled.div`
    align-items: flex-end;
    display: flex;
    margin-right: 10px;
`;

const RankInsightData = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
`;

const RankInsightSkeleton = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: 40px;
`;

export default function RankInsightSmallWidgetSkeletonLayout() {
    return (
        r(Container, [
            r(Row, [
                r(Col, { xs: 6 }, [
                    r(RankInsightSkeleton, [
                        r(Skeleton, { height: '17px', margin: '0 0 3px', width: '17px' }),
                        r(Skeleton, { height: '13px', width: '55px' }),
                    ]),
                ]),
                r(Col, { xs: 6 }, [
                    r(RankInsightSkeleton, [
                        r(Skeleton, { height: '17px', margin: '0 0 3px', width: '17px' }),
                        r(Skeleton, { height: '13px', width: '55px' }),
                    ]),
                ]),
                r(Col, { xs: 6 }, [
                    r(RankInsightSkeleton, [
                        r(Skeleton, { height: '17px', margin: '0 0 3px', width: '17px' }),
                        r(Skeleton, { height: '13px', width: '55px' }),
                    ]),
                ]),
                r(Col, { xs: 6 }, [
                    r(RankInsightSkeleton, [
                        r(Skeleton, { height: '17px', margin: '0 0 3px', width: '17px' }),
                        r(Skeleton, { height: '13px', width: '55px' }),
                    ]),
                ]),
                r(Col, { md: 12, sm: 6 }, [
                    r(RankInsightData, { style: { marginTop: 20 } }, [
                        r(Skeleton, { height: '35px', width: '100%' }),
                    ]),
                ]),
                r(Col, { md: 12, sm: 6 }, [
                    r(RankInfoContainer, { style: { marginTop: 10 } }, [
                        r(RankInfoRank, { style: { flex: 1 } }, [
                            r(Skeleton, { height: '17px', width: '51px' }),
                        ]),
                        r(RankInfoRank, [
                            r(Skeleton, { height: '17px', width: '51px' }),
                        ])
                    ])
                ]),
            ])
        ])
    );
}
